"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_TITLE_ELEMENTS = exports.SHOW_WARNINGS = void 0;
/**
 * Specifies if Plottable should show warnings.
 */
exports.SHOW_WARNINGS = true;
/**
 * Specifies if Plottable should add <title> elements to text.
 */
exports.ADD_TITLE_ELEMENTS = true;



//////////////////
// WEBPACK FOOTER
// ./src/core/config.ts
// module id = 25
// module chunks = 0